import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);


import auth from './auth.module';
import lottoHolidays from './lotto-holidays.module';
import lottoCategory from './lotto-category.module';
import lottoResult from './lotto-result.module';

const store = new Vuex.Store({
    modules: {
        auth,
        lottoHolidays,
        lottoResult,
        lottoCategory
    }
})

export default store